export default class NoOpErrorHandler {
    async handleErrors(_) {
        return false;
    }
}
//# sourceMappingURL=NoOpErrorHandler.js.map